export const FIDELITY_COPY = 'subscriptionForm:fidelity_maximizer_module'
export const JOURNEY_COPY = `${FIDELITY_COPY}.journey`

export const PENDING_REGISTRATION_SCENARIO = 'myselectra_registration_pending'
export const FULLY_LOYAL_SCENARIO = 'fully_loyal'
export const MYSELECTRA_NO_APP_SCENARIO = 'myselectra_no_app'
export const HANDOVER_ACTION = 'myselectra_registration'

export const JOURNEY_VIEWS = {
  LEGACY: 'legacy',
  SEND: 'send',
  CONNECTION: 'connection',
  NO_CODE: 'no_code',
  ACTIVATED: 'activated',
  APP_LINKS: 'app_links',
  MAXIMIZED: 'maximized',
  STATUS_ONLY: 'status_only',
} as const

export type JourneyView = (typeof JOURNEY_VIEWS)[keyof typeof JOURNEY_VIEWS]

export const CONNECTION_CHOICES = { APP: 'app', EMAIL: 'email' } as const

export type ConnectionChoiceValue = (typeof CONNECTION_CHOICES)[keyof typeof CONNECTION_CHOICES]

export type PillState = 'ok' | 'wait' | 'todo'

interface JourneyViewInput {
  journeyEnabled: boolean
  scenarioKey: string | null
  primaryActionKey: string | null
  actionAvailable: boolean
  noCodeExpected: boolean
  journeyStartedForContact: boolean
  myselectraAccount: boolean
}

export const resolveJourneyView = ({
  journeyEnabled,
  scenarioKey,
  primaryActionKey,
  actionAvailable,
  noCodeExpected,
  journeyStartedForContact,
  myselectraAccount,
}: JourneyViewInput): JourneyView => {
  if (!journeyEnabled) return JOURNEY_VIEWS.LEGACY
  if (scenarioKey === PENDING_REGISTRATION_SCENARIO) {
    return noCodeExpected ? JOURNEY_VIEWS.NO_CODE : JOURNEY_VIEWS.CONNECTION
  }
  if (scenarioKey === FULLY_LOYAL_SCENARIO) {
    return journeyStartedForContact ? JOURNEY_VIEWS.ACTIVATED : JOURNEY_VIEWS.MAXIMIZED
  }
  if (scenarioKey === MYSELECTRA_NO_APP_SCENARIO) {
    return journeyStartedForContact ? JOURNEY_VIEWS.ACTIVATED : JOURNEY_VIEWS.APP_LINKS
  }
  if (primaryActionKey === HANDOVER_ACTION && actionAvailable) {
    return noCodeExpected ? JOURNEY_VIEWS.NO_CODE : JOURNEY_VIEWS.SEND
  }
  if (journeyStartedForContact && myselectraAccount) return JOURNEY_VIEWS.ACTIVATED
  return JOURNEY_VIEWS.STATUS_ONLY
}

const WAITING_CHECKLIST_KEYS = ['nlbp_classic', 'nlbp_personalized', 'myselectra']

export const resolvePillState = (key: string, done: boolean, registrationPending: boolean): PillState => {
  if (done) return 'ok'
  if (registrationPending && WAITING_CHECKLIST_KEYS.includes(key)) return 'wait'
  return 'todo'
}

const STEP_INDEX_BY_VIEW: Partial<Record<JourneyView, number>> = {
  [JOURNEY_VIEWS.SEND]: 0,
  [JOURNEY_VIEWS.CONNECTION]: 1,
  [JOURNEY_VIEWS.NO_CODE]: 1,
  [JOURNEY_VIEWS.ACTIVATED]: 3,
}

export const resolveStepIndex = (view: JourneyView): number | null => STEP_INDEX_BY_VIEW[view] ?? null

export const groupCode = (code: string): string => (code.match(/.{1,3}/g) ?? []).join(' ')

export const joinFieldLabels = (labels: string[]): string =>
  new Intl.ListFormat('fr', { style: 'long', type: 'conjunction' }).format(labels)
